/** Notifications about a time-away request (request, approval, rejection). */
const TIME_AWAY_REQUEST_TYPES = [
  'HOLIDAY_PAID_REQUEST',
  'HOLIDAY_UNPAID_REQUEST',
  'HOLIDAY_APPROVED',
  'HOLIDAY_REJECTED',
];

/**
 * The id of the time-away request a notification is about.
 *
 * The notification's own `id` is the notification, not the request. The
 * notification list sends the request as `request_id` (null when there is
 * none); `requestId` and the metadata copy are accepted as well.
 */
export function getNotificationRequestId(
  notification: any,
): string | undefined {
  const requestId =
    notification?.request_id ??
    notification?.requestId ??
    notification?.metadata?.requestId ??
    notification?.metadata?.request_id;

  if (requestId === undefined || requestId === null || requestId === '') {
    return undefined;
  }
  return String(requestId);
}

/** Where clicking a notification should go, or null when nowhere. */
export function getNotificationLink(notification: any): string | null {
  const type = String(notification?.type ?? '').toUpperCase();

  if (TIME_AWAY_REQUEST_TYPES.includes(type)) {
    const requestId = getNotificationRequestId(notification);
    // Without a request id there is no request to open.
    return requestId ? `/time-off/${encodeURIComponent(requestId)}` : null;
  }

  switch (type) {
    case 'CARRYOVER_DEADLINE_NUDGE':
      return '/time-off';
    case 'ABSENCE_PATTERN_ALERT':
      return '/reports/absenteeism-risk';
    default:
      return null;
  }
}
